const ZWIFT_WORLDS = [
  {
    id: 1,
    name: 'Watopia',
    slug: 'watopia',
    bounds: [[-11.611604156240318, 166.86293125], [-11.74087, 167.04708874999997]],
    fictionalRegion: true
  },
  {
    id: 2,
    name: 'Richmond',
    slug: 'richmond',
    bounds: [[37.5774, -77.48954], [37.5014, -77.394]]
  },
  {
    id: 3,
    name: 'London',
    slug: 'london',
    bounds: [[51.55045460650879, -0.1776], [51.4601, -0.0555]]
  },
  {
    id: 4,
    name: 'New York',
    slug: 'new-york',
    bounds: [[40.817257, -74.022655], [40.587913, -73.922165]]
  },
  {
    id: 5,
    name: 'Innsbruck',
    slug: 'innsbruck',
    bounds: [[47.2947, 11.3501], [47.2055, 11.4822]]
  },
  {
    id: 6,
    name: 'Bologna',
    slug: 'bologna',
    bounds: [[44.5308037, 11.26261748], [44.45463821, 11.36991729102076]]
  },
  {
    id: 7,
    name: 'Yorkshire',
    slug: 'yorkshire',
    bounds: [[54.0254, -1.632], [53.9491, -1.5022]]
  },
  {
    id: 8,
    name: 'Crit City',
    slug: 'crit-city',
    bounds: [[-10.3657, 165.7824], [-10.4038, 165.8207]],
    fictionalRegion: true
  },
  {
    id: 9,
    name: 'Makuri Islands',
    slug: 'makuri-islands',
    bounds: [[-10.73746, 165.76591], [-10.85234, 165.88222]],
    fictionalRegion: true
  },
  {
    id: 10,
    name: 'France',
    slug: 'france',
    bounds: [[-21.64155, 166.1200044921875], [-21.7564, 166.26125]],
    fictionalRegion: true
  },
  {
    id: 11,
    name: 'Paris',
    slug: 'paris',
    bounds: [[48.9058, 2.2561], [48.82945, 2.3722]]
  },
  {
    id: 13,
    name: 'Scotland',
    slug: 'scotland',
    bounds: [[55.67595, -5.2802], [55.61845, -5.17798]]
  }
];

const getActivityTypeCandidates = (activity) => [
  activity?.type,
  activity?.sport_type
].filter((value) => typeof value === 'string');

const getLatLng = (value) => {
  if (!Array.isArray(value) || value.length < 2) {
    return null;
  }

  const lat = Number(value[0]);
  const lng = Number(value[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return [lat, lng];
};

export const getZwiftWorld = (latLng) => {
  if (!latLng) {
    return null;
  }

  return ZWIFT_WORLDS.find((world) => {
    const bounds = world.bounds;
    return (
      bounds[0][0] >= latLng[0] &&
      latLng[0] >= bounds[1][0] &&
      bounds[0][1] <= latLng[1] &&
      latLng[1] <= bounds[1][1]
    );
  }) || null;
};

export const getZwiftWorldForActivity = (activity) => {
  if (!activity) {
    return null;
  }

  const isVirtualActivity = getActivityTypeCandidates(activity)
    .some((type) => type === 'VirtualRide' || type === 'VirtualRun');
  if (!isVirtualActivity) {
    return null;
  }

  const world = getZwiftWorld(getLatLng(activity.start_latlng));
  if (!world) {
    return null;
  }

  if (Object.prototype.hasOwnProperty.call(activity, 'device_name')) {
    const deviceName = typeof activity.device_name === 'string' ? activity.device_name.toLowerCase() : '';
    // Dual-recorded Zwift rides (e.g. a head unit in virtual-cycling mode)
    // carry the recorder's device name, not "Zwift". Coordinates inside a
    // fictional world can only come from Zwift, so bounds alone decide there;
    // the device check still excludes real-route virtual platforms (Rouvy,
    // FulGaz) whose rides land inside real-location world bounds.
    if (!deviceName.includes('zwift') && world.fictionalRegion !== true) {
      return null;
    }
  }

  return world;
};

export const isZwiftActivity = (activity) => getZwiftWorldForActivity(activity) !== null;

// Matches the special "Zwift Map" style by name (tolerates an emoji prefix
// and a "3D" variant suffix). This style renders the literal Zwift world map,
// so it is pinned first for Zwift activities on /create and excluded from the
// auto-upload style pool.
export const isZwiftMapStyleName = (name) => {
  if (typeof name !== 'string') return false;
  const normalized = name
    .replace(/\s*3D\s*$/i, '')
    .replace(/^[^a-zA-Z0-9]+/, '')
    .trim()
    .toLowerCase();
  return normalized === 'zwift map';
};
